import {
  ComplaintsCategoriesDocument,
  CreateComplaintsCategoryDocument,
  CreateComplaintsCategoryMutation,
  CreateComplaintsCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateComplaintsCategory = () => {
  const [executeMutation, { loading }] = useMutation(CreateComplaintsCategoryDocument, {
    extractorFn: (data: CreateComplaintsCategoryMutation) =>
      data.complaintsMutations.createComplaintsCategory,
  })

  const createComplaintsCategory = async (variables: CreateComplaintsCategoryMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsCategoriesDocument],
    })
  }

  return {
    createComplaintsCategory,
    loading,
  }
}
